/**
 * Phase L — Ivy League Consulting text logo mark.
 *
 * Placeholder until a real vector asset lands. Same treatment as the
 * Beyond Valencia wordmark: serif small-caps, brass rule underneath.
 */
export default function IvyLeagueConsultingLogo({ variant = "dark", className = "" }) {
  const colorText = variant === "light" ? "text-bone" : "text-ivy";
  const colorRule = variant === "light" ? "bg-brass-soft" : "bg-brass";
  return (
    <div className={`inline-flex flex-col items-start ${className}`} data-testid="ilc-logo">
      <div className={`font-serif tracking-[0.24em] uppercase text-[13px] font-medium ${colorText}`}>
        Ivy League Consulting
      </div>
      <div className={`mt-1 h-px w-full ${colorRule}`} />
      <div className={`mt-1 text-[9px] uppercase tracking-[0.28em] ${variant === "light" ? "text-brass-soft" : "text-brass"}`}>
        Est. Partner
      </div>
    </div>
  );
}
